import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import Layout from './Layout';
import withAuth from './WithAuth';
import AuthService from './AuthService';
import constants from '../config';
import BuylistOfferCard from './BuylistOfferCard';
import { loadShareRef } from '../utils/shareRef';

var Auth = new AuthService();

var AVATAR_COLORS = ['#e67e22', '#3498db', '#2ecc71', '#9b59b6', '#e74c3c', '#1abc9c', '#f39c12', '#d35400'];
function getAvatarColor(name) {
  var hash = 0;
  for (var i = 0; i < (name || '').length; i++) { hash = name.charCodeAt(i) + ((hash << 5) - hash); }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
function renderInitialAvatar(name, size, profilePic) {
  var s = size || 40;
  if (profilePic) {
    var imgSrc = profilePic.indexOf('http') === 0 ? profilePic : constants.DOMAIN + '/' + profilePic;
    return React.createElement('div', {
      style: { width: s, height: s, borderRadius: '50%', overflow: 'hidden', flexShrink: 0 },
    }, React.createElement('img', { src: imgSrc, alt: '', style: { width: '100%', height: '100%', objectFit: 'cover' } }));
  }
  var initial = (name || '?').charAt(0).toUpperCase();
  return React.createElement('div', {
    style: { width: s, height: s, borderRadius: '50%', backgroundColor: getAvatarColor(name), display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: '#fff', fontWeight: 600, fontSize: Math.round(s * 0.4) },
  }, initial);
}
function renderAdminAvatar(size) {
  var s = size || 40;
  return React.createElement('div', {
    style: { width: s, height: s, borderRadius: '50%', backgroundColor: '#8B5CF6', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: '#fff', fontSize: Math.round(s * 0.4) },
  }, React.createElement('i', { className: 'fa fa-shield' }));
}

function isSameCalendarDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear()
    && d1.getMonth() === d2.getMonth()
    && d1.getDate() === d2.getDate();
}

function formatDateSeparator(date) {
  var now = new Date();
  var timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

  if (isSameCalendarDay(date, now)) {
    return 'Today';
  }

  var yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (isSameCalendarDay(date, yesterday)) {
    return 'Yesterday ' + timeStr;
  }

  var sevenDaysAgo = new Date(now);
  sevenDaysAgo.setDate(now.getDate() - 7);
  if (date > sevenDaysAgo) {
    var dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
    return dayName + ' ' + timeStr;
  }

  if (date.getFullYear() === now.getFullYear()) {
    var weekdayShort = date.toLocaleDateString('en-US', { weekday: 'short' });
    var monthShort   = date.toLocaleDateString('en-US', { month: 'short' });
    var dayNum       = date.getDate();
    return weekdayShort + ', ' + monthShort + ' ' + dayNum + ' at ' + timeStr;
  }

  return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
}

class Messages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      conversations: [],
      loading: true,
      selectedConvo: null,
      messages: [],
      messagesLoading: false,
      messagesPage: 1,
      messagesPages: 1,
      messagesTotal: 0,
      newMessage: '',
      sending: false,
      // New message search
      showNewMessage: false,
      searchQuery: '',
      searchResults: [],
      searchLoading: false,
      // Edit message
      editingMessageId: null,
      editingText: '',
      editSaving: false,
      // Offer interactions
      respondingToOffer: null,
      counterAmount: '',
      offerResponding: false,
      // Block/Report
      showUserMenu: false,
      isBlockedByMe: false,
      isBlockedByThem: false,
      blockLoading: false,
      blockConfirmOpen: false,
      reportModalOpen: false,
      reportReason: '',
      reportDetails: '',
      reportSubmitting: false,
      reportSuccess: false,
      reportAlreadyReported: false,
    };
    this.fetchConversations = this.fetchConversations.bind(this);
    this.selectConversation = this.selectConversation.bind(this);
    this.fetchMessages = this.fetchMessages.bind(this);
    this.handleSend = this.handleSend.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleNewMessageToggle = this.handleNewMessageToggle.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSelectUser = this.handleSelectUser.bind(this);
    this.handleEditMessage = this.handleEditMessage.bind(this);
    this.handleSaveEdit = this.handleSaveEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handleDeleteConversation = this.handleDeleteConversation.bind(this);
    this.handleOfferRespond = this.handleOfferRespond.bind(this);
    this.handleSendCounter = this.handleSendCounter.bind(this);
    this.handleBuylistOfferRespond = this.handleBuylistOfferRespond.bind(this);
    this.markAllRead = this.markAllRead.bind(this);
    this.handleBlockUser = this.handleBlockUser.bind(this);
    this.confirmBlockUser = this.confirmBlockUser.bind(this);
    this.handleUnblockUser = this.handleUnblockUser.bind(this);
    this.handleReportUser = this.handleReportUser.bind(this);
    this.submitUserReport = this.submitUserReport.bind(this);
    this.pollInterval = null;
    this._searchTimer = null;
  }

  componentDidMount() {
    this.fetchConversations();
    var self = this;
    this.pollInterval = setInterval(function() {
      if (self.state.selectedConvo) {
        self.fetchMessages(self.state.selectedConvo._id, 1, true);
      }
      self.fetchConversations(true);
    }, 15000);
    this._handleThemeChanged = function() { self.forceUpdate(); };
    window.addEventListener('themeChanged', this._handleThemeChanged);
  }

  componentWillUnmount() {
    if (this.pollInterval) clearInterval(this.pollInterval);
    if (this._searchTimer) clearTimeout(this._searchTimer);
    window.removeEventListener('themeChanged', this._handleThemeChanged);
  }

  fetchConversations(silent) {
    var self = this;
    if (!silent) self.setState({ loading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages')
      .then(function(data) {
        var convos = data.conversations || [];
        self.setState({ conversations: convos, loading: false });

        // Auto-select conversation if navigated from orders/admin page
        if (!silent && self.props.location && self.props.location.state && self.props.location.state.conversationId) {
          var targetId = self.props.location.state.conversationId;
          var match = convos.find(function(c) { return c._id === targetId; });
          if (match) {
            self.selectConversation(match);
          }
          // Clear the state so refresh doesn't re-select
          self.props.history.replace('/messages');
        }
      })
      .catch(function(err) {
        console.log('Failed to fetch conversations:', err);
        if (!silent) self.setState({ loading: false });
      });
  }

  markAllRead() {
    if (this.state.markingAllRead) return;
    var self = this;
    self.setState({ markingAllRead: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/mark-all-read', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function() {
        self.fetchConversations();
        self.setState({ markingAllRead: false });
      })
      .catch(function(err) {
        console.log('Failed to mark all as read:', err);
        self.setState({ markingAllRead: false });
      });
  }

  selectConversation(convo) {
    var self = this;
    self.setState({
      selectedConvo: convo, messages: [], messagesLoading: true, newMessage: '', showNewMessage: false,
      searchQuery: '', searchResults: [], editingMessageId: null, sellerOfferOpen: false, sellerOfferAmount: '',
      showUserMenu: false, isBlockedByMe: convo.isBlockedByMe || false, isBlockedByThem: convo.isBlockedByThem || false,
      reportModalOpen: false, reportReason: '', reportDetails: '', reportSuccess: false, reportAlreadyReported: false,
    });
    self.fetchMessages(convo._id, 1);
  }

  fetchMessages(convoId, page, silent) {
    var self = this;
    if (!silent) self.setState({ messagesLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/' + convoId + '?page=' + (page || 1) + '&limit=50')
      .then(function(data) {
        self.setState({
          messages: data.messages || [],
          messagesPage: data.page || 1,
          messagesPages: data.pages || 1,
          messagesTotal: data.total || 0,
          messagesLoading: false,
          isBlockedByMe: data.isBlockedByMe || false,
          isBlockedByThem: data.isBlockedByThem || false,
        });
        if (!silent) {
          setTimeout(function() {
            var container = document.getElementById('messages-container');
            if (container) container.scrollTop = container.scrollHeight;
          }, 50);
        }
      })
      .catch(function(err) {
        console.log('Failed to fetch messages:', err);
        if (!silent) self.setState({ messagesLoading: false });
      });
  }

  handleSend() {
    var self = this;
    var text = self.state.newMessage.trim();
    if (!text || !self.state.selectedConvo) return;
    self.setState({ sending: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/' + self.state.selectedConvo._id, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: text }),
    })
      .then(function(data) {
        var msgs = self.state.messages.slice();
        msgs.push(data.message);
        self.setState({ messages: msgs, newMessage: '', sending: false });
        var convos = self.state.conversations.map(function(c) {
          if (c._id === self.state.selectedConvo._id) {
            return Object.assign({}, c, { lastMessage: text.slice(0, 100), lastMessageAt: new Date().toISOString() });
          }
          return c;
        });
        self.setState({ conversations: convos });
        setTimeout(function() {
          var container = document.getElementById('messages-container');
          if (container) container.scrollTop = container.scrollHeight;
        }, 50);
      })
      .catch(function(err) {
        self.setState({ sending: false });
        if (err.response) {
          err.response.json().then(function(data) {
            alert(data.error || 'Failed to send message');
          }).catch(function() {
            alert('Failed to send message: ' + (err.message || 'Unknown error'));
          });
        } else {
          alert('Failed to send message: ' + (err.message || 'Unknown error'));
        }
      });
  }

  handleEditMessage(msg) {
    this.setState({ editingMessageId: msg._id, editingText: msg.text });
  }

  handleCancelEdit() {
    this.setState({ editingMessageId: null, editingText: '', editSaving: false });
  }

  handleSaveEdit() {
    var self = this;
    var text = self.state.editingText.trim();
    if (!text) return;
    self.setState({ editSaving: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/' + self.state.editingMessageId + '/edit', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: text }),
    })
      .then(function(data) {
        var msgs = self.state.messages.map(function(m) {
          if (m._id === self.state.editingMessageId) {
            return data.message;
          }
          return m;
        });
        self.setState({ messages: msgs, editingMessageId: null, editingText: '', editSaving: false });
      })
      .catch(function(err) {
        self.setState({ editSaving: false });
        if (err.response) {
          err.response.json().then(function(data) {
            alert(data.error || 'Failed to edit message');
          }).catch(function() {
            alert('Failed to edit message: ' + (err.message || 'Unknown error'));
          });
        } else {
          alert('Failed to edit message: ' + (err.message || 'Unknown error'));
        }
      });
  }

  handleDeleteConversation() {
    if (!this.state.selectedConvo) return;
    if (!window.confirm('Delete this conversation? It will be removed from your list.')) return;
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/' + self.state.selectedConvo._id + '/delete-conversation', {
      method: 'DELETE',
    })
      .then(function() {
        var convos = self.state.conversations.filter(function(c) {
          return c._id !== self.state.selectedConvo._id;
        });
        self.setState({ conversations: convos, selectedConvo: null, messages: [] });
      })
      .catch(function(err) {
        alert('Failed to delete conversation: ' + (err.message || 'Unknown error'));
      });
  }

  handleBack() {
    this.setState({ selectedConvo: null, messages: [], editingMessageId: null, respondingToOffer: null, counterAmount: '', showUserMenu: false, isBlockedByMe: false, isBlockedByThem: false });
  }

  handleBlockUser() {
    this.setState({ blockConfirmOpen: true, showUserMenu: false });
  }

  confirmBlockUser() {
    var self = this;
    var convo = self.state.selectedConvo;
    if (!convo) return;
    var currentUserId = self.props.user && self.props.user._id;
    var otherUser = null;
    for (var i = 0; i < convo.participants.length; i++) {
      if (convo.participants[i]._id !== currentUserId) { otherUser = convo.participants[i]; break; }
    }
    if (!otherUser) return;
    self.setState({ blockLoading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/block/' + otherUser._id, {
      method: 'POST',
    })
      .then(function() {
        self.setState({ blockLoading: false, blockConfirmOpen: false, isBlockedByMe: true });
        // Update conversation in list
        var convos = self.state.conversations.map(function(c) {
          if (c._id === convo._id) { c.isBlockedByMe = true; }
          return c;
        });
        self.setState({ conversations: convos });
      })
      .catch(function(err) {
        self.setState({ blockLoading: false, blockConfirmOpen: false });
        if (err && err.response && typeof err.response.json === 'function') {
          err.response.json().then(function(body) {
            alert(body.error || 'Failed to block user');
          }).catch(function() { alert('Failed to block user'); });
        } else {
          alert('Failed to block user');
        }
      });
  }

  handleUnblockUser() {
    var self = this;
    var convo = self.state.selectedConvo;
    if (!convo) return;
    var currentUserId = self.props.user && self.props.user._id;
    var otherUser = null;
    for (var i = 0; i < convo.participants.length; i++) {
      if (convo.participants[i]._id !== currentUserId) { otherUser = convo.participants[i]; break; }
    }
    if (!otherUser) return;
    self.setState({ blockLoading: true, showUserMenu: false });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/block/' + otherUser._id, {
      method: 'DELETE',
    })
      .then(function() {
        self.setState({ blockLoading: false, isBlockedByMe: false });
        var convos = self.state.conversations.map(function(c) {
          if (c._id === convo._id) { c.isBlockedByMe = false; }
          return c;
        });
        self.setState({ conversations: convos });
      })
      .catch(function(err) {
        self.setState({ blockLoading: false });
        alert('Failed to unblock user: ' + (err.message || 'Unknown error'));
      });
  }

  handleReportUser() {
    this.setState({ reportModalOpen: true, showUserMenu: false, reportReason: '', reportDetails: '', reportSuccess: false, reportAlreadyReported: false });
  }

  submitUserReport() {
    var self = this;
    var convo = self.state.selectedConvo;
    if (!convo || !self.state.reportReason) return;
    var currentUserId = self.props.user && self.props.user._id;
    var otherUser = null;
    for (var i = 0; i < convo.participants.length; i++) {
      if (convo.participants[i]._id !== currentUserId) { otherUser = convo.participants[i]; break; }
    }
    if (!otherUser) return;
    self.setState({ reportSubmitting: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/report/' + otherUser._id, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason: self.state.reportReason, details: self.state.reportDetails }),
    })
      .then(function() {
        self.setState({ reportSubmitting: false, reportSuccess: true });
      })
      .catch(function(err) {
        self.setState({ reportSubmitting: false });
        if (err && err.response && typeof err.response.json === 'function') {
          err.response.json().then(function(body) {
            if (body.alreadyReported) {
              self.setState({ reportAlreadyReported: true });
            } else {
              alert(body.error || 'Failed to report user');
            }
          }).catch(function() {
            alert('Failed to report user');
          });
        } else {
          alert('Failed to report user');
        }
      });
  }

  handleOfferRespond(messageId, action) {
    var self = this;
    self.setState({ offerResponding: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/' + messageId + '/respond', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: action }),
    })
      .then(function() {
        self.setState({ offerResponding: false });
        if (self.state.selectedConvo) {
          self.fetchMessages(self.state.selectedConvo._id, 1);
        }
      })
      .catch(function(err) {
        self.setState({ offerResponding: false });
        alert('Failed to respond to offer: ' + (err.error || err.message || 'Unknown error'));
      });
  }

  handleSendCounter(messageId) {
    var self = this;
    var amount = Number(self.state.counterAmount);
    // Find the offer message to check its post's share settings
    var offerMsg = self.state.messages.find(function(m) { return m._id === messageId; });
    var offerPost = offerMsg && offerMsg.offerPost;
    var minCounter = 0.75;
    if (offerPost && offerPost.allowSharing && offerPost.shareCommissionType === 'amount' && offerPost.shareCommission) {
      var shareFloor = Math.ceil((Number(offerPost.shareCommission) + 1.00) / 0.90 * 100) / 100;
      if (shareFloor > minCounter) minCounter = shareFloor;
    }
    // 20% of listing price floor
    if (offerPost && offerPost.price) {
      var priceFloor = Math.ceil(Number(offerPost.price) * 0.20 * 100) / 100;
      if (priceFloor > minCounter) minCounter = priceFloor;
    }
    // Direction-aware: seller counters higher, buyer counters lower
    var currentUserId = self.props.user && self.props.user._id;
    var isSeller = offerPost && offerPost.user && String(offerPost.user) === String(currentUserId);
    if (isSeller) {
      // Seller must counter higher than the buyer's offer
      if (!amount || amount <= Number(offerMsg.offerAmount)) {
        alert('Counter must be higher than the offer ($' + Number(offerMsg.offerAmount).toFixed(2) + ')');
        return;
      }
    } else {
      // Buyer must counter lower than seller's counter, but above minimum
      if (!amount || amount >= Number(offerMsg.offerAmount)) {
        alert('Counter must be lower than the seller\'s offer ($' + Number(offerMsg.offerAmount).toFixed(2) + ')');
        return;
      }
      if (amount < minCounter) {
        alert('Minimum counter-offer is $' + minCounter.toFixed(2));
        return;
      }
    }
    self.setState({ offerResponding: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages/' + messageId + '/respond', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'counter', amount: amount }),
    })
      .then(function() {
        self.setState({ offerResponding: false, respondingToOffer: null, counterAmount: '' });
        if (self.state.selectedConvo) {
          self.fetchMessages(self.state.selectedConvo._id, 1);
        }
      })
      .catch(function(err) {
        self.setState({ offerResponding: false });
        if (err.response) {
          err.response.json().then(function(data) {
            alert(data.error || 'Failed to send counter-offer');
          }).catch(function() {
            alert('Failed to send counter-offer: ' + (err.message || 'Unknown error'));
          });
        } else {
          alert('Failed to send counter-offer: ' + (err.message || 'Unknown error'));
        }
      });
  }

  handleBuylistOfferRespond(offerId, action) {
    var self = this;
    if (action === 'accept') {
      Auth.fetch(constants.DOMAIN + '/api/v1/buylist/offer/' + offerId + '/respond', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'accept' }),
      }).then(function(res) {
        if (res.postIds) {
          self.props.history.push('/buylist/checkout/' + offerId);
        } else {
          if (self.state.selectedConvo) {
            self.fetchMessages(self.state.selectedConvo._id, 1);
          }
        }
      }).catch(function(err) {
        err.response ? err.response.json().then(function(d) { alert(d.error || 'Failed'); }).catch(function() { alert('Failed to accept offer'); }) : alert('Failed to accept offer');
      });
    } else if (action === 'decline') {
      Auth.fetch(constants.DOMAIN + '/api/v1/buylist/offer/' + offerId + '/respond', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'decline' }),
      }).then(function() {
        if (self.state.selectedConvo) {
          self.fetchMessages(self.state.selectedConvo._id, 1);
        }
      }).catch(function() { alert('Failed to decline offer'); });
    } else if (action === 'counter') {
      // For now, counter redirects — could open a modal
      alert('Counter offers for buylist coming soon. You can decline and discuss in messages.');
    }
  }

  handleNewMessageToggle() {
    this.setState(function(prev) {
      return { showNewMessage: !prev.showNewMessage, searchQuery: '', searchResults: [] };
    });
  }

  handleSearchChange(e) {
    var val = e.target.value;
    var self = this;
    self.setState({ searchQuery: val, searchResults: [], searchLoading: val.length >= 2 });
    if (self._searchTimer) clearTimeout(self._searchTimer);
    if (val.length < 2) {
      self.setState({ searchLoading: false });
      return;
    }
    self._searchTimer = setTimeout(function() {
      Auth.fetch(constants.DOMAIN + '/api/v1/messages/search-users?q=' + encodeURIComponent(val))
        .then(function(data) {
          self.setState({ searchResults: data.users || [], searchLoading: false });
        })
        .catch(function() {
          self.setState({ searchResults: [], searchLoading: false });
        });
    }, 400);
  }

  handleSelectUser(user) {
    var self = this;
    self.setState({ showNewMessage: false, searchQuery: '', searchResults: [], loading: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/messages', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: user._id }),
    })
      .then(function(data) {
        if (data.conversation) {
          self.fetchConversations();
          self.selectConversation(data.conversation);
        }
      })
      .catch(function(err) {
        console.log('Failed to create conversation:', err);
        self.setState({ loading: false });
      });
  }

  render() {
    var self = this;
    var currentUserId = this.props.user ? this.props.user._id : null;
    var isAdmin = this.props.user && this.props.user.role === 'admin';
    var selectedConvo = this.state.selectedConvo;
    var isDark = document.documentElement.classList.contains('tw-dark');

    return (
      <Layout>
        <Helmet><title>Messages | Primal TCG</title></Helmet>
        <div className="tw-max-w-6xl tw-mx-auto tw-px-4 tw-py-4">
          <div className="tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-border tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-overflow-hidden" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 8px 24px rgba(0,0,0,0.06)' }}>
            <div className="tw-flex" style={{ height: 'calc(100vh - 120px)', minHeight: 500, maxHeight: 800 }}>
              {/* Conversation List */}
              <div
                className={'tw-border-r tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-overflow-y-auto tw-flex tw-flex-col' + (selectedConvo ? ' tw-hidden md:tw-flex' : '')}
                style={{ width: selectedConvo ? 340 : '100%', maxWidth: selectedConvo ? 340 : '100%', backgroundColor: isDark ? '#141414' : '#fafafa' }}
              >
                {/* Sidebar Header */}
                <div className="tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-4 tw-flex-shrink-0" style={{ borderBottom: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                  <h2 className="tw-text-lg tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Messages</h2>
                  <div className="tw-flex tw-items-center tw-gap-2">
                    {this.state.conversations.some(function(c) { return (c.unread || 0) > 0; }) && (
                      <button
                        onClick={this.markAllRead}
                        disabled={this.state.markingAllRead}
                        className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-font-medium tw-transition-colors"
                        style={{ color: '#c9a84c', padding: '4px 0', opacity: this.state.markingAllRead ? 0.5 : 1 }}
                        onMouseEnter={function(e) { if (!e.currentTarget.disabled) e.currentTarget.style.opacity = '0.7'; }}
                        onMouseLeave={function(e) { if (!e.currentTarget.disabled) e.currentTarget.style.opacity = '1'; }}
                      >
                        Mark all read
                      </button>
                    )}
                    <button
                      onClick={this.handleNewMessageToggle}
                      className="tw-bg-transparent tw-border-0 tw-p-1.5 tw-cursor-pointer tw-rounded-full tw-transition-colors"
                      style={{ color: this.state.showNewMessage ? (isDark ? '#fff' : '#666') : '#c9a84c', transition: 'color 200ms ease, background-color 200ms ease' }}
                      onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#2a2a2a' : '#f5f3ee'; }}
                      onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                      title="New message"
                    >
                      <i className={'fa ' + (this.state.showNewMessage ? 'fa-times' : 'fa-pencil-square-o')} style={{ fontSize: '1.1em' }} />
                    </button>
                  </div>
                </div>

                {/* Admin tab removed — admin support conversations are now handled in Admin Dashboard > Support Inbox */}

                {/* New Message Search */}
                {this.state.showNewMessage && (
                  <div className="tw-px-3 tw-py-2 tw-border-b tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-flex-shrink-0" style={{ position: 'relative' }}>
                    <input
                      type="text"
                      value={this.state.searchQuery}
                      onChange={this.handleSearchChange}
                      placeholder="Search by username..."
                      autoFocus
                      className="tw-w-full tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-border-[#e8e8e8] dark:tw-border-[#333] tw-bg-[#f5f5f5] dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white"
                    />
                    {(this.state.searchResults.length > 0 || this.state.searchLoading) && (
                      <div
                        className="tw-bg-white dark:tw-bg-[#222] tw-border tw-border-[#e8e8e8] dark:tw-border-[#333] tw-rounded-lg tw-shadow-lg tw-overflow-hidden"
                        style={{ position: 'absolute', top: '100%', left: 12, right: 12, zIndex: 20, maxHeight: 240, overflowY: 'auto' }}
                      >
                        {this.state.searchLoading ? (
                          <div className="tw-px-3 tw-py-3 tw-text-center">
                            <i className="fa fa-circle-o-notch fa-spin tw-text-sm" style={{ color: '#c9a84c' }} />
                          </div>
                        ) : (
                          this.state.searchResults.map(function(u) {
                            return (
                              <div
                                key={u._id}
                                onClick={function() { self.handleSelectUser(u); }}
                                className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-cursor-pointer hover:tw-bg-[#fafafa] dark:hover:tw-bg-[#2a2a2a] tw-transition-colors"
                              >
                                {renderInitialAvatar(u.userName, 28, u.picture)}
                                <span className="tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-font-medium">{u.userName}</span>
                              </div>
                            );
                          })
                        )}
                      </div>
                    )}
                    {this.state.searchQuery.length >= 2 && !this.state.searchLoading && this.state.searchResults.length === 0 && (
                      <p className="tw-text-xs tw-text-[#999] tw-m-0 tw-mt-1 tw-text-center">No users found</p>
                    )}
                  </div>
                )}

                {/* Conversation List Content */}
                <div className="tw-flex-1 tw-overflow-y-auto">
                  {this.state.loading ? (
                    <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
                      <i className="fa fa-circle-o-notch fa-spin tw-text-2xl" style={{ color: '#c9a84c' }} />
                    </div>
                  ) : (function() {
                    var filteredConvos = self.state.conversations;
                    // Admin users: hide admin-type conversations (handled in Admin Dashboard > Support Inbox)
                    if (isAdmin) {
                      filteredConvos = filteredConvos.filter(function(c) { return c.type !== 'admin'; });
                    }
                    if (filteredConvos.length === 0) {
                      return (
                        <div className="tw-text-center tw-py-16 tw-px-6">
                          <div className="tw-w-16 tw-h-16 tw-rounded-full tw-mx-auto tw-mb-4 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#222' : '#f5f3ee' }}>
                            <i className="fa fa-envelope-o tw-text-2xl" style={{ color: '#c9a84c' }} />
                          </div>
                          <p className="tw-text-sm tw-font-medium tw-text-[#666] dark:tw-text-[#aaa] tw-m-0">
                            No conversations yet
                          </p>
                          <p className="tw-text-xs tw-text-[#999] dark:tw-text-[#666] tw-m-0 tw-mt-1">
                            Start a conversation from a product page or use the compose button above
                          </p>
                        </div>
                      );
                    }
                    return filteredConvos.map(function(convo) {
                      var otherUser = null;
                      if (convo.participants) {
                        for (var i = 0; i < convo.participants.length; i++) {
                          if (convo.participants[i]._id !== currentUserId) {
                            otherUser = convo.participants[i];
                            break;
                          }
                        }
                      }
                      var isSelected = selectedConvo && selectedConvo._id === convo._id;
                      var unread = convo.unread || 0;
                      var timeStr = '';
                      if (convo.lastMessageAt) {
                        var d = new Date(convo.lastMessageAt);
                        var now = new Date();
                        if (d.toDateString() === now.toDateString()) {
                          timeStr = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
                        } else {
                          timeStr = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                        }
                      }

                      return (
                        <div
                          key={convo._id}
                          onClick={function() { self.selectConversation(convo); }}
                          className={'tw-flex tw-items-start tw-gap-3 tw-cursor-pointer hover:tw-bg-white dark:hover:tw-bg-[#1e1e1e]' + (isSelected ? '' : '')}
                          style={{ transition: 'background-color 200ms ease, border-color 200ms ease', padding: '14px 16px 14px 16px', borderLeft: isSelected ? '3px solid #c9a84c' : '3px solid transparent', paddingLeft: isSelected ? '13px' : '16px', backgroundColor: isSelected ? (isDark ? '#1e1c17' : '#fff') : 'transparent', borderBottom: '1px solid ' + (isDark ? '#1e1e1e' : '#f0f0f0') }}
                        >
                          <div style={{ borderRadius: '50%', padding: isSelected ? '2px' : '0px', background: isSelected ? 'linear-gradient(135deg, #c9a84c, #b8953f)' : 'transparent', flexShrink: 0, transition: 'padding 200ms ease' }}>
                            {convo.type === 'admin' && !isAdmin ? renderAdminAvatar(isSelected ? 36 : 40) : renderInitialAvatar(otherUser ? otherUser.userName : '?', isSelected ? 36 : 40, otherUser && otherUser.image)}
                          </div>
                          <div className="tw-flex-1 tw-min-w-0">
                            <div className="tw-flex tw-items-center tw-justify-between">
                              <span className={'tw-text-sm tw-truncate tw-flex tw-items-center tw-gap-1.5 ' + (unread > 0 ? 'tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white' : 'tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white')}>
                                {convo.type === 'admin' && !isAdmin ? 'Primal Support' : (otherUser ? otherUser.userName : 'Unknown')}
                                {convo.type === 'admin' && (
                                  <span className="tw-text-[9px] tw-font-bold tw-px-1.5 tw-py-0.5 tw-rounded tw-text-white tw-flex-shrink-0" style={{ backgroundColor: '#8B5CF6', letterSpacing: '0.5px' }}>ADMIN</span>
                                )}
                              </span>
                              <span className="tw-text-xs tw-text-[#999] tw-flex-shrink-0 tw-ml-2">{timeStr}</span>
                            </div>
                            <div className="tw-flex tw-items-center tw-justify-between tw-mt-0.5">
                              <p className={'tw-text-xs tw-truncate tw-m-0 ' + (unread > 0 ? 'tw-font-semibold tw-text-[#555] dark:tw-text-[#ccc]' : 'tw-text-[#999]')}>
                                {convo.lastMessage || 'No messages yet'}
                              </p>
                              {unread > 0 && (
                                <span className="tw-flex-shrink-0 tw-ml-2 tw-w-5 tw-h-5 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-[10px] tw-font-bold tw-text-white" style={{ backgroundColor: '#c9a84c' }}>
                                  {unread > 9 ? '9+' : unread}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    });
                  })()}
                </div>
              </div>

              {/* Message Thread */}
              {selectedConvo ? (
                <div className="tw-flex-1 tw-flex tw-flex-col tw-min-w-0">
                  {/* Thread Header */}
                  <div className="tw-px-5 tw-py-3.5" style={{ backgroundColor: isDark ? '#161616' : '#fff', borderBottom: '1px solid ' + (isDark ? '#222' : '#eee') }}>
                    <div className="tw-flex tw-items-center tw-gap-3">
                      <button
                        onClick={this.handleBack}
                        className="tw-bg-transparent tw-border-0 tw-p-0 tw-text-[#999] tw-cursor-pointer hover:tw-text-[#666] dark:hover:tw-text-white tw-transition-colors"
                      >
                        <i className="fa fa-arrow-left tw-text-lg" />
                      </button>
                      {(function() {
                        var otherUser = null;
                        if (selectedConvo.participants) {
                          for (var i = 0; i < selectedConvo.participants.length; i++) {
                            if (selectedConvo.participants[i]._id !== currentUserId) {
                              otherUser = selectedConvo.participants[i];
                              break;
                            }
                          }
                        }
                        var isAdminConvoForUser = selectedConvo.type === 'admin' && !isAdmin;
                        if (isAdminConvoForUser) {
                          return (
                            <div className="tw-flex tw-items-center tw-gap-2.5">
                              {renderAdminAvatar(36)}
                              <div>
                                <span className="tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-flex tw-items-center tw-gap-1.5" style={{ display: 'flex' }}>
                                  Primal Support
                                  <span className="tw-text-[9px] tw-font-bold tw-px-1.5 tw-py-0.5 tw-rounded tw-text-white" style={{ backgroundColor: '#8B5CF6', letterSpacing: '0.5px' }}>ADMIN</span>
                                </span>
                                <span className="tw-text-[10px] tw-font-medium" style={{ color: '#8B5CF6' }}>Official Support</span>
                              </div>
                            </div>
                          );
                        }
                        var profileLink = otherUser ? '/shop/' + otherUser.userName : '#';
                        return (
                          <a href={profileLink} className="tw-flex tw-items-center tw-gap-2.5 tw-no-underline hover:tw-opacity-80 tw-transition-opacity">
                            {renderInitialAvatar(otherUser ? otherUser.userName : '?', 36, otherUser && otherUser.image)}
                            <div>
                              <span className="tw-text-sm tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-flex tw-items-center tw-gap-1.5" style={{ display: 'flex' }}>
                                {otherUser ? otherUser.userName : 'Unknown'}
                                {selectedConvo.type === 'admin' && (
                                  <span className="tw-text-[9px] tw-font-bold tw-px-1.5 tw-py-0.5 tw-rounded tw-text-white" style={{ backgroundColor: '#8B5CF6', letterSpacing: '0.5px' }}>ADMIN</span>
                                )}
                              </span>
                              <span className="tw-text-[10px] tw-font-medium" style={{ color: isDark ? '#666' : '#aaa' }}>View shop</span>
                            </div>
                          </a>
                        );
                      })()}
                      <div className="tw-ml-auto tw-flex tw-items-center tw-gap-2">
                        {selectedConvo.status !== 'active' && (
                          <span className="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-medium" style={{ backgroundColor: '#FEF2F2', color: '#B91C1C' }}>
                            {selectedConvo.status === 'admin_closed' ? 'Closed' : selectedConvo.status}
                          </span>
                        )}
                        {(self.state.isBlockedByMe || self.state.isBlockedByThem) && (
                          <span className="tw-text-xs tw-px-2 tw-py-0.5 tw-rounded-full tw-font-medium" style={{ backgroundColor: '#FEE2E2', color: '#991B1B' }}>
                            Blocked
                          </span>
                        )}
                        <div className="tw-relative">
                          <button
                            onClick={function() { self.setState(function(prev) { return { showUserMenu: !prev.showUserMenu }; }); }}
                            className="tw-bg-transparent tw-border-0 tw-p-1.5 tw-cursor-pointer tw-rounded-full tw-text-[#bbb] hover:tw-text-[#666] dark:hover:tw-text-white tw-transition-colors"
                            style={{ transition: 'color 200ms ease, background-color 200ms ease' }}
                            onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#2a2a2a' : '#f0f0f0'; }}
                            onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                            title="More options"
                          >
                            <i className="fa fa-ellipsis-v tw-text-base" />
                          </button>
                          {self.state.showUserMenu && (
                            <div className="tw-absolute tw-right-0 tw-top-full tw-mt-1 tw-w-48 tw-bg-white dark:tw-bg-[#222] tw-rounded-lg tw-shadow-lg tw-border tw-border-[#e8e8e8] dark:tw-border-[#333] tw-z-50 tw-overflow-hidden">
                              {!(selectedConvo.type === 'admin' && !isAdmin) && (
                                self.state.isBlockedByMe ? (
                                  <button
                                    onClick={self.handleUnblockUser}
                                    disabled={self.state.blockLoading}
                                    className="tw-w-full tw-text-left tw-px-4 tw-py-2.5 tw-text-sm tw-border-0 tw-cursor-pointer tw-flex tw-items-center tw-gap-2 hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#2a2a2a]"
                                    style={{ backgroundColor: 'transparent', color: '#10B981' }}
                                  >
                                    <i className="fa fa-unlock tw-w-4 tw-text-center" /> Unblock User
                                  </button>
                                ) : (
                                  <button
                                    onClick={self.handleBlockUser}
                                    disabled={self.state.blockLoading}
                                    className="tw-w-full tw-text-left tw-px-4 tw-py-2.5 tw-text-sm tw-border-0 tw-cursor-pointer tw-flex tw-items-center tw-gap-2 hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#2a2a2a]"
                                    style={{ backgroundColor: 'transparent', color: '#EF4444' }}
                                  >
                                    <i className="fa fa-ban tw-w-4 tw-text-center" /> Block User
                                  </button>
                                )
                              )}
                              {!(selectedConvo.type === 'admin' && !isAdmin) && (
                                <button
                                  onClick={self.handleReportUser}
                                  className="tw-w-full tw-text-left tw-px-4 tw-py-2.5 tw-text-sm tw-border-0 tw-cursor-pointer tw-flex tw-items-center tw-gap-2 hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#2a2a2a]"
                                  style={{ backgroundColor: 'transparent', color: '#F59E0B' }}
                                >
                                  <i className="fa fa-flag tw-w-4 tw-text-center" /> Report User
                                </button>
                              )}
                              {!(selectedConvo.type === 'admin' && !isAdmin) && (
                                <div className="tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#333]" />
                              )}
                              <button
                                onClick={function() { self.setState({ showUserMenu: false }); self.handleDeleteConversation(); }}
                                className="tw-w-full tw-text-left tw-px-4 tw-py-2.5 tw-text-sm tw-border-0 tw-cursor-pointer tw-flex tw-items-center tw-gap-2 hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#2a2a2a]"
                                style={{ backgroundColor: 'transparent', color: '#EF4444' }}
                              >
                                <i className="fa fa-trash-o tw-w-4 tw-text-center" /> Delete Conversation
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Admin conversation banner */}
                    {selectedConvo.type === 'admin' && (
                      <div className="tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2" style={{ backgroundColor: isDark ? 'rgba(139,92,246,0.1)' : 'rgba(139,92,246,0.08)', borderBottom: '1px solid ' + (isDark ? 'rgba(139,92,246,0.2)' : 'rgba(139,92,246,0.15)') }}>
                        <i className="fa fa-shield" style={{ color: '#8B5CF6', fontSize: '12px' }} />
                        <span className="tw-text-xs tw-font-medium" style={{ color: '#8B5CF6' }}>Official Admin Conversation</span>
                      </div>
                    )}

                  </div>

                  {/* Messages */}
                  <div id="messages-container" className="tw-flex-1 tw-overflow-y-auto tw-px-5 tw-py-5 tw-space-y-3" style={{ background: isDark ? 'linear-gradient(180deg, #0f0f0f 0%, #131313 100%)' : 'linear-gradient(180deg, #f8f7f4 0%, #f2f0eb 100%)' }}>
                    {self.state.messagesLoading && self.state.messages.length === 0 ? (
                      <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
                        <i className="fa fa-circle-o-notch fa-spin tw-text-2xl" style={{ color: '#c9a84c' }} />
                      </div>
                    ) : self.state.messages.length === 0 ? (
                      <div className="tw-text-center tw-py-12">
                        <div className="tw-w-12 tw-h-12 tw-rounded-full tw-mx-auto tw-mb-3 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#222' : '#f5f3ee' }}>
                          <i className="fa fa-comment-o tw-text-lg" style={{ color: '#c9a84c' }} />
                        </div>
                        <p className="tw-text-sm tw-font-medium tw-text-[#888] tw-m-0">No messages yet</p>
                        <p className="tw-text-xs tw-text-[#bbb] tw-m-0 tw-mt-1">Send a message to start the conversation</p>
                      </div>
                    ) : (
                      self.state.messages.reduce(function(acc, msg, idx) {
                        var isMine = msg.sender && msg.sender._id === currentUserId;
                        var isEditing = self.state.editingMessageId === msg._id;
                        var msgType = msg.messageType || 'text';

                        // Date separator — show before the first message of each new calendar day
                        var prevMsg = idx > 0 ? self.state.messages[idx - 1] : null;
                        var showSep = !prevMsg || !isSameCalendarDay(new Date(msg.createdAt), new Date(prevMsg.createdAt));
                        if (showSep) {
                          acc.push(
                            <div key={'sep-' + msg._id} className="tw-flex tw-justify-center tw-pt-4 tw-pb-2">
                              <span
                                className="tw-text-[11px] tw-font-medium tw-px-3 tw-py-1 tw-rounded-full"
                                style={{ backgroundColor: isDark ? '#252525' : '#ede9e1', color: isDark ? '#999' : '#888', letterSpacing: '0.01em' }}
                              >
                                {formatDateSeparator(new Date(msg.createdAt))}
                              </span>
                            </div>
                          );
                        }

                        // Buylist offer response — centered system message
                        if (msgType === 'buylist_offer_response') {
                          var blrColor = '#888';
                          if (msg.text && msg.text.indexOf('accepted') !== -1) blrColor = '#16a34a';
                          else if (msg.text && msg.text.indexOf('declined') !== -1) blrColor = '#ef4444';
                          else if (msg.text && msg.text.indexOf('Counter') !== -1) blrColor = '#c9a84c';
                          acc.push(
                            <div key={msg._id} className="tw-flex tw-justify-center">
                              <span className="tw-text-xs tw-font-medium tw-px-3 tw-py-1 tw-rounded-full" style={{ backgroundColor: blrColor + '15', color: blrColor }}>
                                {msg.text}
                              </span>
                            </div>
                          );
                          return acc;
                        }

                        // Buylist offer card
                        if (msgType === 'buylist_offer' && msg.buylistOffer) {
                          var blOffer = msg.buylistOffer;
                          var blIsBuyer = blOffer.buyer && (blOffer.buyer._id === currentUserId || blOffer.buyer === currentUserId);
                          acc.push(
                            <div key={msg._id} className={'tw-flex tw-items-end tw-gap-2 ' + (isMine ? 'tw-justify-end' : 'tw-justify-start')}>
                              {!isMine && (selectedConvo.type === 'admin' && !isAdmin ? renderAdminAvatar(24) : renderInitialAvatar(msg.sender ? msg.sender.userName : '?', 24, msg.sender && msg.sender.image))}
                              <BuylistOfferCard
                                offer={blOffer}
                                isBuyer={blIsBuyer}
                                onRespond={function(offerId, action) {
                                  self.handleBuylistOfferRespond(offerId, action);
                                }}
                              />
                            </div>
                          );
                          return acc;
                        }

                        // Offer response — centered system message
                        if (msgType === 'offer_response') {
                          var responseColor = '#888';
                          if (msg.text && msg.text.indexOf('accepted') !== -1) responseColor = '#16a34a';
                          else if (msg.text && msg.text.indexOf('declined') !== -1) responseColor = '#ef4444';
                          else if (msg.text && msg.text.indexOf('counter') !== -1 || msg.text && msg.text.indexOf('Counter') !== -1) responseColor = '#c9a84c';
                          acc.push(
                            <div key={msg._id} className="tw-flex tw-justify-center">
                              <span className="tw-text-xs tw-font-medium tw-px-3 tw-py-1 tw-rounded-full" style={{ backgroundColor: responseColor + '15', color: responseColor }}>
                                {msg.text}
                              </span>
                            </div>
                          );
                          return acc;
                        }

                        // Offer card
                        if (msgType === 'offer') {
                          var post = msg.offerPost;
                          var status = msg.offerStatus || 'pending';
                          var statusColors = { pending: '#c9a84c', accepted: '#16a34a', declined: '#ef4444', countered: '#888', expired: '#888' };
                          var statusLabels = { pending: 'Pending', accepted: 'Accepted', declined: 'Declined', countered: 'Countered', expired: 'Expired' };
                          var borderColor = isMine ? '#c9a84c' : '#16a34a';
                          var canRespond = status === 'pending' && !isMine && !self.state.offerResponding;
                          var postOwner = post && post.user ? String(post.user) : null;
                          var isSeller = postOwner === String(currentUserId);
                          var canBuy = status === 'accepted' && !isSeller && post && !post.sold;
                          var isCountering = self.state.respondingToOffer === msg._id;

                          // Expiration countdown
                          var expiresText = '';
                          if (status === 'pending' && msg.offerExpiresAt) {
                            var msLeft = new Date(msg.offerExpiresAt).getTime() - Date.now();
                            if (msLeft > 0) {
                              var hoursLeft = Math.floor(msLeft / 3600000);
                              var minsLeft = Math.floor((msLeft % 3600000) / 60000);
                              expiresText = 'Expires in ' + hoursLeft + 'h ' + minsLeft + 'm';
                            } else {
                              expiresText = 'Expired';
                            }
                          }

                          // Listing thumbnail (fall back to cardImage if no uploaded images)
                          var offerThumb = null;
                          if (post && post.images && post.images.length > 0) {
                            offerThumb = post.images[0];
                          } else if (post && post.cardImage) {
                            offerThumb = post.cardImage;
                          }
                          if (offerThumb && offerThumb.indexOf('http') !== 0) {
                            offerThumb = constants.DOMAIN + '/' + offerThumb;
                          }

                          acc.push(
                            <div key={msg._id} className={'tw-flex tw-items-end tw-gap-2 ' + (isMine ? 'tw-justify-end' : 'tw-justify-start')}>
                              {!isMine && (selectedConvo.type === 'admin' && !isAdmin ? renderAdminAvatar(24) : renderInitialAvatar(msg.sender ? msg.sender.userName : '?', 24, msg.sender && msg.sender.image))}
                              <div className="tw-w-72 tw-rounded-xl tw-overflow-hidden" style={{ border: '2px solid ' + borderColor, backgroundColor: isDark ? '#1a1a1a' : '#fff' }}>
                                {/* Offer header */}
                                <div className="tw-px-3 tw-py-2 tw-flex tw-items-center tw-justify-between" style={{ backgroundColor: borderColor + '10' }}>
                                  <span className="tw-text-xs tw-font-bold tw-flex tw-items-center" style={{ color: borderColor }}><i className="fa fa-tag tw-mr-1" /> {isMine ? 'Your Offer' : 'Offer Received'}</span>
                                  <span className="tw-text-[10px] tw-font-semibold tw-px-2 tw-py-0.5 tw-rounded-full" style={{ backgroundColor: statusColors[status] + '20', color: statusColors[status] }}>
                                    {statusLabels[status]}
                                  </span>
                                </div>
                                {/* Listing preview */}
                                {post && (
                                  <div className="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-border-b" style={{ borderColor: isDark ? '#333' : '#eee' }}>
                                    {offerThumb ? (
                                      <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-overflow-hidden tw-flex-shrink-0" style={{ backgroundColor: isDark ? '#333' : '#eee' }}>
                                        <img src={offerThumb} alt="" className="tw-w-full tw-h-full tw-object-cover" />
                                      </div>
                                    ) : (
                                      <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#333' : '#eee' }}>
                                        <i className="fa fa-image tw-text-[#ccc] tw-text-xs" />
                                      </div>
                                    )}
                                    <div className="tw-flex-1 tw-min-w-0">
                                      <p className="tw-text-xs tw-font-medium tw-m-0 tw-truncate" style={{ color: isDark ? '#e5e5e5' : '#1a1a1a' }}>{post.title}</p>
                                      <p className="tw-text-xs tw-text-[#999] tw-m-0">Listed: <span className="tw-font-bold" style={{ color: '#c9a84c' }}>${Number(post.price).toFixed(2)}</span></p>
                                    </div>
                                  </div>
                                )}
                                {/* Offer amount */}
                                <div className="tw-text-center tw-py-3">
                                  <p className="tw-text-2xl tw-font-bold tw-m-0" style={{ color: '#16a34a' }}>${Number(msg.offerAmount).toFixed(2)}</p>
                                  {expiresText && (
                                    <p className="tw-text-[10px] tw-text-[#999] tw-m-0 tw-mt-1"><i className="fa fa-clock-o" /> {expiresText}</p>
                                  )}
                                </div>
                                {/* Payout breakdown for seller only */}
                                {canRespond && post && post.user && String(post.user) === String(currentUserId) && (function() {
                                  var offerPrice = Number(msg.offerAmount);
                                  var platformFee = Math.max(0.75, offerPrice * 0.10);
                                  var shipping = post.shippingCost || 0;
                                  var commission = 0;
                                  if (post.allowSharing && post.shareCommission) {
                                    commission = post.shareCommissionType === 'amount'
                                      ? Number(post.shareCommission)
                                      : Math.max(1, offerPrice * (Number(post.shareCommission) / 100));
                                    var baseSeller = (offerPrice * 0.90) + shipping;
                                    if (commission > baseSeller) commission = baseSeller;
                                  }
                                  var payout = (offerPrice - platformFee) + shipping - commission;
                                  var payoutRatio = offerPrice > 0 ? payout / offerPrice : 0;
                                  var payoutColor = payoutRatio >= 0.50 ? '#16a34a' : payoutRatio >= 0.25 ? '#ea580c' : '#ef4444';
                                  return (
                                    <div className="tw-mx-3 tw-mb-2 tw-rounded-lg tw-px-3 tw-py-2 tw-text-xs" style={{ backgroundColor: isDark ? '#1a1a1a' : '#f5f5f5' }}>
                                      <div className="tw-flex tw-justify-between tw-mb-1">
                                        <span style={{ color: isDark ? '#aaa' : '#666' }}>Offer price</span>
                                        <span style={{ color: isDark ? '#e5e5e5' : '#1a1a1a' }}>${offerPrice.toFixed(2)}</span>
                                      </div>
                                      <div className="tw-flex tw-justify-between tw-mb-1">
                                        <span style={{ color: isDark ? '#aaa' : '#666' }}>Platform fee {platformFee > offerPrice * 0.10 ? '(min)' : '(10%)'}</span>
                                        <span style={{ color: '#ef4444' }}>-${platformFee.toFixed(2)}</span>
                                      </div>
                                      {commission > 0 && (
                                        <div className="tw-flex tw-justify-between tw-mb-1">
                                          <span style={{ color: isDark ? '#aaa' : '#666' }}>Share commission</span>
                                          <span style={{ color: '#ef4444' }}>-${commission.toFixed(2)}</span>
                                        </div>
                                      )}
                                      {shipping > 0 && (
                                        <div className="tw-flex tw-justify-between tw-mb-1">
                                          <span style={{ color: isDark ? '#aaa' : '#666' }}>Shipping</span>
                                          <span style={{ color: '#16a34a' }}>+${shipping.toFixed(2)}</span>
                                        </div>
                                      )}
                                      <div style={{ borderTop: '1px solid ' + (isDark ? '#333' : '#ddd'), marginTop: '4px', paddingTop: '4px' }} className="tw-flex tw-justify-between tw-items-center tw-font-bold">
                                        <span style={{ color: isDark ? '#ccc' : '#333' }}>Your payout</span>
                                        <span className="tw-flex tw-items-center" style={{ color: payoutColor }}>
                                          {payoutRatio < 0.25 && <i className="fa fa-exclamation-triangle tw-mr-1" style={{ fontSize: '10px' }} />}
                                          ${payout.toFixed(2)}
                                        </span>
                                      </div>
                                    </div>
                                  );
                                })()}
                                {/* Action buttons */}
                                {canRespond && !isCountering && (
                                  <div className="tw-flex tw-gap-1.5 tw-px-3 tw-pb-3">
                                    <button
                                      onClick={function() { self.handleOfferRespond(msg._id, 'accept'); }}
                                      className="tw-flex-1 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-bold tw-border-none tw-cursor-pointer tw-text-white"
                                      style={{ backgroundColor: '#16a34a' }}
                                    >Accept</button>
                                    <button
                                      onClick={function() { self.setState({ respondingToOffer: msg._id, counterAmount: '' }); }}
                                      className="tw-flex-1 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-bold tw-border-none tw-cursor-pointer tw-text-black"
                                      style={{ backgroundColor: '#c9a84c' }}
                                    >Counter</button>
                                    <button
                                      onClick={function() { self.handleOfferRespond(msg._id, 'decline'); }}
                                      className="tw-flex-1 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-bold tw-cursor-pointer tw-bg-transparent"
                                      style={{ border: '1px solid #ef4444', color: '#ef4444' }}
                                    >Decline</button>
                                  </div>
                                )}
                                {/* Counter input */}
                                {canRespond && isCountering && (function() {
                                  var isSeller = post && post.user && String(post.user) === String(currentUserId);
                                  var offerAmt = Number(msg.offerAmount);
                                  var minCounter = 0.75;
                                  if (post && post.allowSharing && post.shareCommissionType === 'amount' && post.shareCommission) {
                                    var shareFloor = Math.ceil((Number(post.shareCommission) + 1.00) / 0.90 * 100) / 100;
                                    if (shareFloor > minCounter) minCounter = shareFloor;
                                  }
                                  if (post && post.price) {
                                    var priceFloor = Math.ceil(Number(post.price) * 0.20 * 100) / 100;
                                    if (priceFloor > minCounter) minCounter = priceFloor;
                                  }
                                  // Seller: min is above the offer. Buyer: max is below the offer, min is the floor.
                                  var inputMin = isSeller ? (offerAmt + 0.01) : minCounter;
                                  var inputMax = isSeller ? (Number(post.price) - 0.01) : (offerAmt - 0.01);
                                  var hint = isSeller
                                    ? 'Must be above $' + offerAmt.toFixed(2)
                                    : 'Min: $' + minCounter.toFixed(2) + ' · Max: $' + (offerAmt - 0.01).toFixed(2);
                                  return (
                                  <div className="tw-px-3 tw-pb-3">
                                    <div className="tw-relative tw-mb-1">
                                      <span className="tw-absolute tw-left-2.5 tw-text-sm tw-font-bold tw-text-[#999]" style={{ top: '50%', transform: 'translateY(-55%)' }}>$</span>
                                      <input
                                        type="number"
                                        step="0.01"
                                        min={inputMin}
                                        max={inputMax}
                                        value={self.state.counterAmount}
                                        onChange={function(e) { self.setState({ counterAmount: e.target.value }); }}
                                        placeholder="Your counter price"
                                        autoFocus
                                        className="tw-w-full tw-pl-7 tw-pr-2 tw-py-2 tw-text-sm tw-font-bold tw-rounded-full tw-border tw-outline-none"
                                        style={{ boxSizing: 'border-box', backgroundColor: isDark ? '#222' : '#fff', color: isDark ? '#e5e5e5' : '#1a1a1a', borderColor: isDark ? '#444' : '#e0e0e0' }}
                                      />
                                    </div>
                                    <p className="tw-text-[10px] tw-m-0 tw-mb-2 tw-pl-3" style={{ color: isDark ? '#777' : '#999' }}>{hint}</p>
                                    <div className="tw-flex tw-gap-1.5">
                                      <button
                                        onClick={function() { self.handleSendCounter(msg._id); }}
                                        disabled={!self.state.counterAmount || self.state.offerResponding}
                                        className="tw-flex-1 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-bold tw-border-none tw-cursor-pointer tw-text-black disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                                        style={{ backgroundColor: '#c9a84c' }}
                                      >Send Counter</button>
                                      <button
                                        onClick={function() { self.setState({ respondingToOffer: null, counterAmount: '' }); }}
                                        className="tw-px-3 tw-py-1.5 tw-rounded-lg tw-text-xs tw-font-medium tw-bg-transparent tw-cursor-pointer"
                                        style={{ border: '1px solid ' + (isDark ? '#555' : '#ccc'), color: isDark ? '#aaa' : '#666' }}
                                      >Cancel</button>
                                    </div>
                                  </div>
                                  );
                                })()}
                                {/* Buy Now at offer price — routes through metapurchase if share ref exists */}
                                {canBuy && (function () {
                                  var shareRef = post && post._id ? loadShareRef(post._id) : null;
                                  var buyUrl = shareRef
                                    ? '/metapurchase/' + shareRef + '?offerId=' + msg._id + '&offerPrice=' + msg.offerAmount
                                    : '/purchase/' + post._id + '?offerId=' + msg._id + '&offerPrice=' + msg.offerAmount;
                                  return (
                                  <div className="tw-px-3 tw-pb-3">
                                    <Link
                                      to={buyUrl}
                                      className="tw-block tw-w-full tw-py-2 tw-rounded-lg tw-text-sm tw-font-bold tw-text-center tw-text-black tw-no-underline"
                                      style={{ backgroundColor: '#c9a84c' }}
                                    >
                                      Buy Now at ${Number(msg.offerAmount).toFixed(2)}
                                    </Link>
                                  </div>
                                  );
                                })()}
                                {/* Timestamp */}
                                <div className="tw-px-3 tw-pb-2 tw-text-right">
                                  <span className="tw-text-[10px] tw-text-[#999]">
                                    {new Date(msg.createdAt).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                          return acc;
                        }

                        // Regular text message (default)
                        acc.push(
                          <div key={msg._id} className={'tw-flex tw-items-end tw-gap-2 ' + (isMine ? 'tw-justify-end' : 'tw-justify-start')}>
                            {!isMine && (selectedConvo.type === 'admin' && !isAdmin ? renderAdminAvatar(24) : renderInitialAvatar(msg.sender ? msg.sender.userName : '?', 24, msg.sender && msg.sender.image))}
                            <div
                              className="tw-max-w-xs sm:tw-max-w-sm tw-rounded-2xl tw-px-4 tw-py-2.5"
                              style={Object.assign(
                                { position: 'relative' },
                                isMine
                                  ? { backgroundColor: '#c9a84c', color: '#fff', borderBottomRightRadius: 4, boxShadow: '0 1px 4px rgba(212,168,67,0.2)' }
                                  : { backgroundColor: isDark ? '#1e1e1e' : '#fff', color: isDark ? '#e5e5e5' : '#1a1a1a', borderBottomLeftRadius: 4, border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8'), boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }
                              )}
                            >
                              {isEditing ? (
                                <div>
                                  <textarea
                                    value={self.state.editingText}
                                    onChange={function(e) { self.setState({ editingText: e.target.value }); }}
                                    onKeyDown={function(e) {
                                      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); self.handleSaveEdit(); }
                                      if (e.key === 'Escape') { self.handleCancelEdit(); }
                                    }}
                                    maxLength={2000}
                                    rows={2}
                                    autoFocus
                                    className="tw-w-full tw-px-2 tw-py-1.5 tw-text-sm tw-rounded-lg tw-border tw-border-white/30 tw-bg-white/20 tw-text-white tw-outline-none tw-resize-none"
                                    style={{ minWidth: 200 }}
                                  />
                                  <div className="tw-flex tw-items-center tw-gap-2 tw-mt-1">
                                    <button
                                      onClick={self.handleSaveEdit}
                                      disabled={!self.state.editingText.trim() || self.state.editSaving}
                                      className="tw-bg-white/20 tw-border tw-border-white/30 tw-rounded tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-medium tw-text-white tw-cursor-pointer hover:tw-bg-white/30 disabled:tw-opacity-50"
                                    >
                                      {self.state.editSaving ? 'Saving...' : 'Save'}
                                    </button>
                                    <button
                                      onClick={self.handleCancelEdit}
                                      className="tw-bg-transparent tw-border-0 tw-p-0 tw-text-[10px] tw-text-white/70 tw-cursor-pointer hover:tw-text-white"
                                    >
                                      Cancel
                                    </button>
                                    <span className="tw-text-[9px] tw-text-white/50 tw-ml-auto">Esc to cancel</span>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <p className="tw-text-sm tw-m-0" style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{msg.text}</p>
                                  {/* Inline attached card preview */}
                                  {msg.attachedPost && (function() {
                                    var ap = msg.attachedPost;
                                    var apThumb = null;
                                    if (ap.images && ap.images.length > 0) apThumb = ap.images[0];
                                    else if (ap.cardImage) apThumb = ap.cardImage;
                                    if (apThumb && apThumb.indexOf('http') !== 0) apThumb = constants.DOMAIN + '/' + apThumb;
                                    return (
                                      <a
                                        href={'/product/' + ap._id}
                                        className="tw-block tw-mt-2.5 tw-rounded-xl tw-overflow-hidden tw-no-underline"
                                        style={{ backgroundColor: isMine ? 'rgba(0,0,0,0.35)' : (isDark ? '#1a1a1a' : '#fff'), border: '1px solid ' + (isMine ? 'rgba(0,0,0,0.1)' : (isDark ? '#333' : '#e0e0e0')), boxShadow: '0 1px 4px rgba(0,0,0,0.1)', transition: 'transform 150ms ease, box-shadow 150ms ease' }}
                                        onMouseEnter={function(e) { e.currentTarget.style.transform = 'scale(1.02)'; e.currentTarget.style.boxShadow = '0 3px 12px rgba(0,0,0,0.2)'; }}
                                        onMouseLeave={function(e) { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.1)'; }}
                                      >
                                        <div className="tw-flex tw-items-center tw-gap-3 tw-p-2.5">
                                          {apThumb ? (
                                            <div className="tw-flex-shrink-0 tw-rounded-lg tw-overflow-hidden" style={{ width: 52, height: 52, backgroundColor: '#222' }}>
                                              <img src={apThumb} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                            </div>
                                          ) : (
                                            <div className="tw-flex-shrink-0 tw-rounded-lg tw-flex tw-items-center tw-justify-center" style={{ width: 52, height: 52, backgroundColor: '#222' }}>
                                              <i className="fa fa-image" style={{ color: '#666', fontSize: 16 }} />
                                            </div>
                                          )}
                                          <div className="tw-flex-1 tw-min-w-0">
                                            <p className="tw-text-xs tw-font-semibold tw-m-0 tw-truncate" style={{ color: isMine ? '#f5f5f5' : (isDark ? '#e5e5e5' : '#1a1a1a'), lineHeight: '1.3' }}>{ap.title}</p>
                                            <div className="tw-flex tw-items-center tw-gap-1.5 tw-mt-1">
                                              {ap.price != null && (
                                                <span className="tw-text-sm tw-font-bold" style={{ color: '#c9a84c' }}>${Number(ap.price).toFixed(2)}</span>
                                              )}
                                              {ap.sold && (
                                                <span className="tw-text-[10px] tw-font-semibold tw-px-1.5 tw-py-0.5 tw-rounded" style={{ backgroundColor: 'rgba(239,68,68,0.15)', color: '#ef4444' }}>Sold</span>
                                              )}
                                            </div>
                                          </div>
                                          <div className="tw-flex-shrink-0 tw-w-6 tw-h-6 tw-rounded-full tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isMine ? 'rgba(255,255,255,0.12)' : (isDark ? '#2a2a2a' : '#f5f5f5') }}>
                                            <i className="fa fa-chevron-right" style={{ fontSize: 9, color: isMine ? '#ddd' : '#c9a84c' }} />
                                          </div>
                                        </div>
                                      </a>
                                    );
                                  })()}
                                  {/* Inline attached order preview */}
                                  {msg.attachedOrder && (function() {
                                    var ao = msg.attachedOrder;
                                    var aoPost = ao.post;
                                    var aoTitle = aoPost ? aoPost.title : 'Order';
                                    var aoOrderNum = ao._id ? ao._id.slice(-8).toUpperCase() : '';
                                    return (
                                      <div
                                        className="tw-flex tw-items-center tw-gap-3 tw-mt-2.5 tw-rounded-xl tw-overflow-hidden tw-p-2.5"
                                        style={{ backgroundColor: isMine ? 'rgba(0,0,0,0.2)' : (isDark ? '#1a1a1a' : '#fff'), border: '1px solid ' + (isMine ? 'rgba(0,0,0,0.15)' : (isDark ? '#333' : '#e0e0e0')), boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}
                                      >
                                        <div className="tw-flex-shrink-0 tw-rounded-lg tw-flex tw-items-center tw-justify-center" style={{ width: 44, height: 44, backgroundColor: isMine ? 'rgba(255,255,255,0.1)' : (isDark ? '#2a2a2a' : '#f5f3ee') }}>
                                          <i className="fa fa-shopping-bag" style={{ color: isMine ? 'rgba(255,255,255,0.8)' : '#c9a84c', fontSize: 16 }} />
                                        </div>
                                        <div className="tw-flex-1 tw-min-w-0">
                                          <p className="tw-text-xs tw-font-semibold tw-m-0 tw-truncate" style={{ color: isMine ? '#fff' : (isDark ? '#e5e5e5' : '#1a1a1a') }}>Order #{aoOrderNum}</p>
                                          <p className="tw-text-[10px] tw-m-0 tw-mt-0.5 tw-truncate" style={{ color: isMine ? 'rgba(255,255,255,0.6)' : (isDark ? '#888' : '#666') }}>{aoTitle}</p>
                                        </div>
                                      </div>
                                    );
                                  })()}
                                  <div className="tw-flex tw-items-center tw-gap-2 tw-mt-1" style={{ justifyContent: isMine ? 'flex-end' : 'flex-start' }}>
                                    {msg.editedAt && (
                                      <span className="tw-text-[10px]" style={{ opacity: 0.5, fontStyle: 'italic' }}>edited</span>
                                    )}
                                    <span className="tw-text-[10px]" style={{ opacity: 0.7 }}>
                                      {new Date(msg.createdAt).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}
                                    </span>
                                    {isMine && (
                                      <button
                                        onClick={function(e) { e.stopPropagation(); self.handleEditMessage(msg); }}
                                        className="tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-transition-opacity"
                                        style={{ opacity: 0.4, lineHeight: 1 }}
                                        onMouseEnter={function(e) { e.currentTarget.style.opacity = '0.9'; }}
                                        onMouseLeave={function(e) { e.currentTarget.style.opacity = '0.4'; }}
                                        title="Edit message"
                                      >
                                        <i className="fa fa-pencil" style={{ fontSize: 11, color: isMine ? '#fff' : '#999' }} />
                                      </button>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        );
                        return acc;
                      }, [])
                    )}
                  </div>

                  {/* Input */}
                  {self.state.isBlockedByMe ? (
                    <div className="tw-px-4 tw-py-3 tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" style={{ backgroundColor: isDark ? '#1a1515' : '#FEF2F2' }}>
                      <div className="tw-flex tw-items-center tw-justify-between">
                        <div className="tw-flex tw-items-center tw-gap-2">
                          <i className="fa fa-ban" style={{ color: '#EF4444' }} />
                          <span className="tw-text-sm tw-text-[#991B1B] dark:tw-text-[#FCA5A5]">You have blocked this user</span>
                        </div>
                        <button
                          onClick={self.handleUnblockUser}
                          disabled={self.state.blockLoading}
                          className="tw-px-3 tw-py-1.5 tw-rounded-full tw-border-0 tw-text-xs tw-font-bold tw-cursor-pointer tw-text-white disabled:tw-opacity-50"
                          style={{ backgroundColor: '#10B981' }}
                        >
                          {self.state.blockLoading ? <i className="fa fa-circle-o-notch fa-spin" /> : 'Unblock'}
                        </button>
                      </div>
                    </div>
                  ) : self.state.isBlockedByThem ? (
                    <div className="tw-px-4 tw-py-3 tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]" style={{ backgroundColor: isDark ? '#1a1818' : '#F9FAFB' }}>
                      <div className="tw-flex tw-items-center tw-gap-2 tw-justify-center">
                        <i className="fa fa-ban" style={{ color: '#9CA3AF' }} />
                        <span className="tw-text-sm tw-text-[#6B7280]">You cannot send messages to this user</span>
                      </div>
                    </div>
                  ) : selectedConvo.status === 'active' ? (
                    <div className="tw-px-5 tw-py-3.5" style={{ backgroundColor: isDark ? '#161616' : '#fff', borderTop: '1px solid ' + (isDark ? '#222' : '#eee') }}>
                      <div className="tw-flex tw-gap-3 tw-items-center">
                        <input
                          type="text"
                          value={self.state.newMessage}
                          onChange={function(e) { self.setState({ newMessage: e.target.value }); }}
                          onKeyDown={function(e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); self.handleSend(); } }}
                          placeholder="Type a message..."
                          maxLength={2000}
                          className="tw-flex-1 tw-px-5 tw-py-3 tw-rounded-full tw-border tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-outline-none"
                          style={{ transition: 'border-color 200ms ease, box-shadow 200ms ease', backgroundColor: isDark ? '#1a1a1a' : '#f5f5f5', borderColor: isDark ? '#2a2a2a' : '#e8e8e8' }}
                          onFocus={function(e) { e.currentTarget.style.borderColor = '#c9a84c'; e.currentTarget.style.boxShadow = '0 0 0 3px rgba(212,168,67,0.12)'; e.currentTarget.style.backgroundColor = isDark ? '#1e1e1e' : '#fff'; }}
                          onBlur={function(e) { e.currentTarget.style.borderColor = isDark ? '#2a2a2a' : '#e8e8e8'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.backgroundColor = isDark ? '#1a1a1a' : '#f5f5f5'; }}
                        />
                        <button
                          onClick={self.handleSend}
                          disabled={!self.state.newMessage.trim() || self.state.sending}
                          className="tw-w-11 tw-h-11 tw-rounded-full tw-border-0 tw-text-white tw-cursor-pointer tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 disabled:tw-opacity-40 disabled:tw-cursor-not-allowed"
                          style={{ background: 'linear-gradient(135deg, #c9a84c 0%, #b8953f 100%)', transition: 'transform 150ms ease, box-shadow 200ms ease', boxShadow: '0 2px 8px rgba(212,168,67,0.2)' }}
                          onMouseEnter={function(e) { if (!e.currentTarget.disabled) { e.currentTarget.style.boxShadow = '0 4px 16px rgba(212,168,67,0.4)'; e.currentTarget.style.transform = 'scale(1.05)'; } }}
                          onMouseLeave={function(e) { e.currentTarget.style.boxShadow = '0 2px 8px rgba(212,168,67,0.2)'; e.currentTarget.style.transform = 'scale(1)'; }}
                          onMouseDown={function(e) { if (!e.currentTarget.disabled) e.currentTarget.style.transform = 'scale(0.95)'; }}
                          onMouseUp={function(e) { e.currentTarget.style.transform = 'scale(1.05)'; }}
                        >
                          <i className={self.state.sending ? 'fa fa-circle-o-notch fa-spin' : 'fa fa-paper-plane'} />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="tw-px-4 tw-py-3 tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-text-center">
                      <p className="tw-text-sm tw-text-[#999] tw-m-0">This conversation has been closed</p>
                    </div>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        {/* Click-outside to close dropdown */}
        {self.state.showUserMenu && (
          <div
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 40 }}
            onClick={function() { self.setState({ showUserMenu: false }); }}
          />
        )}

        {/* Block User Confirm Modal */}
        {self.state.blockConfirmOpen && (function() {
          var convo = self.state.selectedConvo;
          var currentUserId = self.props.user && self.props.user._id;
          var otherUser = null;
          if (convo && convo.participants) {
            for (var i = 0; i < convo.participants.length; i++) {
              if (convo.participants[i]._id !== currentUserId) { otherUser = convo.participants[i]; break; }
            }
          }
          var otherName = otherUser ? otherUser.userName : 'this user';
          return (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div
                style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}
                onClick={function() { self.setState({ blockConfirmOpen: false }); }}
              />
              <div className="modal-enter tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-shadow-2xl tw-w-full tw-max-w-sm tw-mx-4 tw-relative tw-z-10 tw-overflow-hidden">
                <div className="tw-p-6 tw-text-center">
                  <div className="tw-w-14 tw-h-14 tw-rounded-full tw-mx-auto tw-mb-3 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#FEE2E2' }}>
                    <i className="fa fa-ban tw-text-xl" style={{ color: '#EF4444' }} />
                  </div>
                  <h3 className="tw-text-lg tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Block {otherName}?</h3>
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-mt-2 tw-m-0">
                    Neither of you will be able to send messages to each other. You can unblock them at any time.
                  </p>
                  <div className="tw-flex tw-gap-3 tw-mt-5 tw-justify-center">
                    <button
                      onClick={function() { self.setState({ blockConfirmOpen: false }); }}
                      className="tw-px-5 tw-py-2 tw-rounded-lg tw-border tw-text-sm tw-font-medium tw-cursor-pointer tw-bg-transparent"
                      style={{ borderColor: isDark ? '#333' : '#ddd', color: isDark ? '#aaa' : '#666' }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={self.confirmBlockUser}
                      disabled={self.state.blockLoading}
                      className="tw-px-5 tw-py-2 tw-rounded-lg tw-border-0 tw-text-sm tw-font-medium tw-text-white tw-cursor-pointer disabled:tw-opacity-50"
                      style={{ backgroundColor: '#EF4444' }}
                    >
                      {self.state.blockLoading ? <i className="fa fa-circle-o-notch fa-spin" /> : 'Block'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })()}

        {/* Report User Modal */}
        {self.state.reportModalOpen && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div
              style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }}
              onClick={function() { self.setState({ reportModalOpen: false }); }}
            />
            <div className="modal-enter tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-shadow-2xl tw-w-full tw-max-w-md tw-mx-4 tw-relative tw-z-10 tw-overflow-hidden">
              {self.state.reportSuccess ? (
                <div className="tw-p-6 tw-text-center">
                  <div className="tw-w-14 tw-h-14 tw-rounded-full tw-mx-auto tw-mb-3 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#ECFDF5' }}>
                    <i className="fa fa-check tw-text-xl" style={{ color: '#10B981' }} />
                  </div>
                  <h3 className="tw-text-lg tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Report Submitted</h3>
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-mt-2 tw-m-0">Thank you for your report. Our team will review it shortly.</p>
                  <button
                    onClick={function() { self.setState({ reportModalOpen: false }); }}
                    className="tw-mt-4 tw-px-6 tw-py-2 tw-rounded-lg tw-border-0 tw-text-white tw-font-medium tw-cursor-pointer"
                    style={{ backgroundColor: '#c9a84c' }}
                  >
                    Done
                  </button>
                </div>
              ) : self.state.reportAlreadyReported ? (
                <div className="tw-p-6 tw-text-center">
                  <div className="tw-w-14 tw-h-14 tw-rounded-full tw-mx-auto tw-mb-3 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: '#FEF3C7' }}>
                    <i className="fa fa-info-circle tw-text-xl" style={{ color: '#F59E0B' }} />
                  </div>
                  <h3 className="tw-text-lg tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Already Reported</h3>
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-mt-2 tw-m-0">You have already reported this user. Our team is reviewing your report.</p>
                  <button
                    onClick={function() { self.setState({ reportModalOpen: false }); }}
                    className="tw-mt-4 tw-px-6 tw-py-2 tw-rounded-lg tw-border-0 tw-text-white tw-font-medium tw-cursor-pointer"
                    style={{ backgroundColor: '#c9a84c' }}
                  >
                    Close
                  </button>
                </div>
              ) : (
                <div>
                  <div className="tw-px-6 tw-py-4 tw-border-b tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a]">
                    <div className="tw-flex tw-items-center tw-justify-between">
                      <h3 className="tw-text-lg tw-font-semibold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Report User</h3>
                      <button
                        onClick={function() { self.setState({ reportModalOpen: false }); }}
                        className="tw-bg-transparent tw-border-0 tw-p-1 tw-cursor-pointer tw-text-[#999] hover:tw-text-[#666]"
                      >
                        <i className="fa fa-times tw-text-lg" />
                      </button>
                    </div>
                  </div>
                  <div className="tw-px-6 tw-py-4">
                    <p className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-m-0 tw-mb-3">Select a reason for reporting this user:</p>
                    <div className="tw-flex tw-flex-wrap tw-gap-2 tw-mb-4">
                      {['Harassment', 'Spam', 'Scam/Fraud', 'Inappropriate Content', 'Other'].map(function(reason) {
                        var isSelected = self.state.reportReason === reason;
                        return (
                          <button
                            key={reason}
                            onClick={function() { self.setState({ reportReason: reason }); }}
                            className="tw-px-3 tw-py-1.5 tw-rounded-full tw-text-xs tw-font-medium tw-cursor-pointer tw-border tw-transition-colors"
                            style={{
                              backgroundColor: isSelected ? '#FEF3C7' : 'transparent',
                              borderColor: isSelected ? '#F59E0B' : (isDark ? '#333' : '#ddd'),
                              color: isSelected ? '#92400E' : (isDark ? '#aaa' : '#666'),
                            }}
                          >
                            {reason}
                          </button>
                        );
                      })}
                    </div>
                    {self.state.reportReason && (
                      <div>
                        <label className="tw-block tw-text-xs tw-font-medium tw-text-[#666] dark:tw-text-[#aaa] tw-mb-1">Additional details (optional)</label>
                        <textarea
                          value={self.state.reportDetails}
                          onChange={function(e) { self.setState({ reportDetails: e.target.value }); }}
                          placeholder="Provide any additional context..."
                          maxLength={500}
                          rows={3}
                          className="tw-w-full tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-border-[#e8e8e8] dark:tw-border-[#333] tw-bg-[#f9f9f9] dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-resize-none"
                          style={{ boxSizing: 'border-box' }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="tw-px-6 tw-py-4 tw-border-t tw-border-[#e8e8e8] dark:tw-border-[#2a2a2a] tw-flex tw-justify-end tw-gap-2">
                    <button
                      onClick={function() { self.setState({ reportModalOpen: false }); }}
                      className="tw-px-4 tw-py-2 tw-rounded-lg tw-border tw-text-sm tw-font-medium tw-cursor-pointer tw-bg-transparent"
                      style={{ borderColor: isDark ? '#333' : '#ddd', color: isDark ? '#aaa' : '#666' }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={self.submitUserReport}
                      disabled={!self.state.reportReason || self.state.reportSubmitting}
                      className="tw-px-4 tw-py-2 tw-rounded-lg tw-border-0 tw-text-sm tw-font-medium tw-text-white tw-cursor-pointer disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                      style={{ backgroundColor: '#EF4444' }}
                    >
                      {self.state.reportSubmitting ? <i className="fa fa-circle-o-notch fa-spin" /> : 'Submit Report'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </Layout>
    );
  }
}

export default withAuth(Messages);
